/**
 * RFC 7807 problem details, as emitted by the backend's GlobalExceptionHandler.
 *
 * Every error response has this shape, which is what lets the API client translate a
 * server-side validation failure straight into react-hook-form field errors.
 */
export interface ApiFieldError {
  field: string
  message: string
  code?: string
}

export interface ApiProblem {
  type: string
  title: string
  status: number
  detail: string
  instance?: string
  /** Stable machine-readable code, e.g. `auth.invalid_credentials`. Branch on this, not on `detail`. */
  code?: string
  correlationId?: string
  timestamp?: string
  errors?: ApiFieldError[]
  [key: string]: unknown
}

export function isApiProblem(value: unknown): value is ApiProblem {
  return (
    typeof value === 'object' &&
    value !== null &&
    'status' in value &&
    'title' in value
  )
}

/** A message safe to show a user, preferring the specific detail over the generic title. */
export function problemMessage(problem: unknown, fallback = 'Something went wrong'): string {
  if (isApiProblem(problem)) {
    return problem.detail || problem.title || fallback
  }
  if (problem instanceof Error) {
    return problem.message
  }
  return fallback
}
